<template>
  <section>
    <div class="container">
      <custom-title-block :title="title" />
      <popular-vacancy-block :subtitle="subtitle" :items="items" />
      <custom-button @click="openVacancyPage">
        <span>{{ button }}</span>
      </custom-button>
    </div>
  </section>
</template>

<script>
import CustomTitleBlock from "@/components/UI/CustomTitle.vue";
import PopularVacancyBlock from "@/components/main/popularVacancy/modules/PopularVacancyBlock.vue";
import CustomButton from "@/components/UI/CustomButton.vue";

export default {
  name: "popular-vacancy",
  components: {
    CustomButton,
    PopularVacancyBlock,
    CustomTitleBlock,
  },
  data() {
    return {
      title: "Популярні вакансії",
      subtitle:
        "Приєднуйся до лав ЗСУ! Ознайомся з популярними вакансіями " +
        "та обери роль, яка найбільше відповідає твоїм навичкам " +
        "і покликанню. Захищай Україну разом із професіоналами!",
      button: "Переглянути всі вакансії",
      items: [
        {
          id: 1,
          title: "Оператор наземних роботизованих комплексів",
        },
        {
          id: 2,
          title: "Зовнішній пілот (оператор) БпЛА\n",
        },
        {
          id: 3,
          title: "Водій-електрик",
        },
        {
          id: 4,
          title: "дешифрувальник розвідувальних матеріалів",
        },
        {
          id: 5,
          title: "Інженер-механік БпЛа",
        },
        {
          id: 6,
          title: "Майстер-вибухотехнік БпЛа",
        },
      ],
    };
  },
  methods: {
    openVacancyPage() {
      this.$router.push("/vacancy/1");
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  font-family: "UAF Sans H", serif;

  @media (max-width: 767px) {
    font-size: 13px !important;
  }
}
</style>
